import { axiosAuthClient } from "..";
import { handleError } from "../../utils/errors";

class AuthService {
  signUp = async ({ email, password, fullName }) => {
    try {
      const body = {
        email,
        password,
        fullName,
      };
      const response = await axiosAuthClient.post("/sign-up", body, {
        withCredentials: true,
      });
      if (response.status !== 201) {
        throw new Error();
      }

      const { accessToken, refreshToken, opsUser } = response.data.data;
      return {
        accessToken,
        refreshToken,
        opsUser,
      };
    } catch (err) {
      throw handleError(
        err,
        "Error occurred while creating new user, status:" + err.code
      );
    }
  };

  login = async ({ email, password }) => {
    try {
      const response = await axiosAuthClient.post(
        "/login",
        {
          email,
          password,
        },
        { withCredentials: true }
      );
      if (response.status !== 201) {
        throw new Error();
      }
      const { accessToken, refreshToken, opsUser } = response.data.data;

      return {
        accessToken,
        refreshToken,
        opsUser,
      };
    } catch (err) {
      throw handleError(
        err,
        "Error occurred while logging in, status:" + err.code
      );
    }
  };

  logout = async () => {
    try {
      const response = await axiosAuthClient.post(
        "/logout",
        {},
        {
          withCredentials: true,
        }
      );
      if (response.status !== 200) {
        throw new Error();
      }
      return;
    } catch (err) {
      throw handleError(err, "Error occurred while logging out");
    }
  };

  refresh = async () => {
    try {
      const response = await axiosAuthClient.get("/refresh-token", {
        withCredentials: true,
      });
      if (response.status !== 200) {
        throw new Error();
      }
      const { accessToken } = response.data.data;
      return { accessToken };
    } catch (err) {
      throw handleError(err, "Error occurred while refresh token");
    }
  };

  sendCodeForNewPassword = async (email) => {
    try {
      const response = await axiosAuthClient.post(
        "/forgotten-password/send-code",
        {
          email,
        }
      );
      if (response.status !== 201) {
        throw new Error();
      }

      return response.data;
    } catch (err) {
      throw handleError(
        err,
        "Error occurred while sending an email to reset password"
      );
    }
  };

  resetPassword = async ({ email, newPassword, code }) => {
    try {
      const response = await axiosAuthClient.post("/reset-password", {
        email,
        newPassword,
        code,
      });
      if (response.status !== 201) {
        throw new Error();
      }

      return response.data;
    } catch (err) {
      throw handleError(err, "Error occurred while resetting password");
    }
  };

  sendVerificationCodeEmailAgain = async ({ email }) => {
    try {
      const response = await axiosAuthClient.post("/verification-email", {
        email,
      });
      if (response.status !== 200) {
        throw new Error();
      }

      return response.data;
    } catch (err) {
      throw handleError(err, "Error occurred while resend code");
    }
  };
}
const authService = new AuthService();

export default authService;
